export const SELECT_ROOM = "SELECT_ROOM";
export const MAKE_STRIPE_PAYMENT = "MAKE_STRIPE_PAYMENT";

export function selectRoom(room, dispatch) {
	dispatch({ type: SELECT_ROOM, room });
}
